/* SetupGear appearance toggle — persists the shopper's local preference. */
(function () {
  const root = document.documentElement;
  const button = document.getElementById('setupgear-appearance-toggle');
  const storageKey = 'setupgear-appearance-mode';

  function setMode(mode, save) {
    const isLight = mode === 'light';
    root.setAttribute('data-sg-theme', isLight ? 'light' : 'dark');
    if (button) {
      button.textContent = isLight ? '☾ Dark mode' : '☼ Light mode';
      button.setAttribute('aria-label', isLight ? 'Switch to dark mode' : 'Switch to light mode');
      button.setAttribute('aria-pressed', isLight ? 'true' : 'false');
    }
    if (save) {
      try { window.localStorage.setItem(storageKey, isLight ? 'light' : 'dark'); } catch (error) {}
    }
  }

  let initialMode = 'dark';
  try {
    const saved = window.localStorage.getItem(storageKey);
    if (saved === 'light' || saved === 'dark') initialMode = saved;
  } catch (error) {}
  setMode(initialMode, false);

  if (button) {
    button.addEventListener('click', function () {
      setMode(root.getAttribute('data-sg-theme') === 'light' ? 'dark' : 'light', true);
    });
  }
})();
